/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setBearerAuthToObject,
  setSearchParams,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * FilterDefinitionsApi - axios parameter creator
 */
export const FilterDefinitionsApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get list of filter definitions
     * @param {ProductTaxonomies} taxonomy Definition of product taxonomies used
     * @param {StorePerimeters} storePerimeter Definition of store perimeters used
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {FilterDefinitionGroup} [group]
     * @param {GetFilterDefinitionViewEnum} [view] View (page) the filters are requested for. Filters restricted to other views are excluded. Omitting it returns every filter the user is allowed to see.
     * @param {number} [limitFilterValue] Maximum number of filter values to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilterDefinition: (
      taxonomy_1,
      storePerimeter_1,
      page_1,
      pageSize_1,
      group_1,
      view_1,
      limitFilterValue_1,
      ...args_1
    ) =>
      __awaiter(
        this,
        [taxonomy_1, storePerimeter_1, page_1, pageSize_1, group_1, view_1, limitFilterValue_1, ...args_1],
        void 0,
        function* (taxonomy, storePerimeter, page, pageSize, group, view, limitFilterValue, options = {}) {
          // verify required parameter 'taxonomy' is not null or undefined
          assertParamExists('getFilterDefinition', 'taxonomy', taxonomy);
          // verify required parameter 'storePerimeter' is not null or undefined
          assertParamExists('getFilterDefinition', 'storePerimeter', storePerimeter);
          const localVarPath = `/api/filter-definition`;
          // use dummy base URL string because the URL constructor only accepts absolute URLs.
          const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
          let baseOptions;
          if (configuration) {
            baseOptions = configuration.baseOptions;
          }
          const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
          const localVarHeaderParameter = {};
          const localVarQueryParameter = {};
          // authentication authorization required
          // http bearer authentication required
          yield setBearerAuthToObject(localVarHeaderParameter, configuration);
          if (page !== undefined) {
            localVarQueryParameter['page'] = page;
          }
          if (pageSize !== undefined) {
            localVarQueryParameter['pageSize'] = pageSize;
          }
          if (group !== undefined) {
            localVarQueryParameter['group'] = group;
          }
          if (taxonomy !== undefined) {
            localVarQueryParameter['taxonomy'] = taxonomy;
          }
          if (storePerimeter !== undefined) {
            localVarQueryParameter['storePerimeter'] = storePerimeter;
          }
          if (view !== undefined) {
            localVarQueryParameter['view'] = view;
          }
          if (limitFilterValue !== undefined) {
            localVarQueryParameter['limitFilterValue'] = limitFilterValue;
          }
          localVarHeaderParameter['Accept'] = 'application/json';
          setSearchParams(localVarUrlObj, localVarQueryParameter);
          let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
          localVarRequestOptions.headers = Object.assign(
            Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
            options.headers
          );
          return {
            url: toPathString(localVarUrlObj),
            options: localVarRequestOptions
          };
        }
      )
  };
};
/**
 * FilterDefinitionsApi - functional programming interface
 */
export const FilterDefinitionsApiFp = function (configuration) {
  const localVarAxiosParamCreator = FilterDefinitionsApiAxiosParamCreator(configuration);
  return {
    /**
     * Get list of filter definitions
     * @param {ProductTaxonomies} taxonomy Definition of product taxonomies used
     * @param {StorePerimeters} storePerimeter Definition of store perimeters used
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {FilterDefinitionGroup} [group]
     * @param {GetFilterDefinitionViewEnum} [view] View (page) the filters are requested for. Filters restricted to other views are excluded. Omitting it returns every filter the user is allowed to see.
     * @param {number} [limitFilterValue] Maximum number of filter values to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilterDefinition(taxonomy, storePerimeter, page, pageSize, group, view, limitFilterValue, options) {
      return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getFilterDefinition(
          taxonomy,
          storePerimeter,
          page,
          pageSize,
          group,
          view,
          limitFilterValue,
          options
        );
        const localVarOperationServerIndex =
          (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null &&
          _a !== void 0
            ? _a
            : 0;
        const localVarOperationServerBasePath =
          (_c =
            (_b = operationServerMap['FilterDefinitionsApi.getFilterDefinition']) === null || _b === void 0
              ? void 0
              : _b[localVarOperationServerIndex]) === null || _c === void 0
            ? void 0
            : _c.url;
        return (axios, basePath) =>
          createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
          )(axios, localVarOperationServerBasePath || basePath);
      });
    }
  };
};
/**
 * FilterDefinitionsApi - factory interface
 */
export const FilterDefinitionsApiFactory = function (configuration, basePath, axios) {
  const localVarFp = FilterDefinitionsApiFp(configuration);
  return {
    /**
     * Get list of filter definitions
     * @param {FilterDefinitionsApiGetFilterDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFilterDefinition(requestParameters, options) {
      return localVarFp
        .getFilterDefinition(
          requestParameters.taxonomy,
          requestParameters.storePerimeter,
          requestParameters.page,
          requestParameters.pageSize,
          requestParameters.group,
          requestParameters.view,
          requestParameters.limitFilterValue,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * FilterDefinitionsApi - object-oriented interface
 */
export class FilterDefinitionsApi extends BaseAPI {
  /**
   * Get list of filter definitions
   * @param {FilterDefinitionsApiGetFilterDefinitionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getFilterDefinition(requestParameters, options) {
    return FilterDefinitionsApiFp(this.configuration)
      .getFilterDefinition(
        requestParameters.taxonomy,
        requestParameters.storePerimeter,
        requestParameters.page,
        requestParameters.pageSize,
        requestParameters.group,
        requestParameters.view,
        requestParameters.limitFilterValue,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
export var GetFilterDefinitionViewEnum;
(function (GetFilterDefinitionViewEnum) {
  GetFilterDefinitionViewEnum['SALES_AMOUNT'] = 'sales-amount';
  GetFilterDefinitionViewEnum['SALES_QUANTITY'] = 'sales-quantity';
  GetFilterDefinitionViewEnum['MARKET_SHARE'] = 'market-share';
  GetFilterDefinitionViewEnum['POSSESSION_RATE'] = 'possession-rate';
  GetFilterDefinitionViewEnum['DN_DV'] = 'dn-dv';
  GetFilterDefinitionViewEnum['DYNAMIC_CLIENT'] = 'dynamic-client';
  GetFilterDefinitionViewEnum['PERFORMANCE'] = 'performance';
  GetFilterDefinitionViewEnum['BUSINESS_EQUATION'] = 'business-equation';
  GetFilterDefinitionViewEnum['CUSTOMER_SEGMENTATION'] = 'customer-segmentation';
  GetFilterDefinitionViewEnum['COMPETITOR_VISION'] = 'competitor-vision';
})(GetFilterDefinitionViewEnum || (GetFilterDefinitionViewEnum = {}));
